import { useRouter } from "next/router";
import React from "react";
import useCollection from "../hooks/useCollection";
import ArrowSvg from "./Carousel/ArrowSvg";

const SideNavDrawer = ({ isOpen, toggleDrawer, store }) => {
  const router = useRouter();
  const {
    data: collectionsData,
    isLoading: isCollectionsLoading,
    error: collectionsError,
  } = useCollection(store.id, "");

  const collections = collectionsData ? collectionsData.collections : [];

  if (collectionsError) return <div>Error loading collections</div>;

  return (
    <aside
      className={`fixed top-0 left-0 h-screen w-screen bg-white shadow-lg transition-transform transform z-[101] overflow-y-auto ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex items-center p-8">
        <span className="font-bold text-lg">{store?.storeName}</span>
        <button
          className="inline-block bg-transparent border-0 w-[22px] absolute top-10 right-5 z-50"
          onClick={toggleDrawer}
          aria-label="Close drawer"
        >
          <div
            className={`w-full h-[15px] relative transform rotate-0 transition duration-500 ease-in-out cursor-pointer ${isOpen ? "open" : ""}`}
          >
            <span
              className={`block absolute h-[2px] w-full bg-primary rounded-lg opacity-100 left-0 transform transition duration-250 ease-in-out top-[7px] ${isOpen ? "rotate-45" : "rotate-0"}`}
            ></span>
            <span
              className={`block absolute h-[2px] w-full bg-primary rounded-lg opacity-100 left-0 transform transition duration-250 ease-in-out top-[7px] ${isOpen ? "-rotate-45" : "rotate-0"}`}
            ></span>
          </div>
        </button>
      </div>
      <nav className="mt-3">
        <ul className="space-y-0">
          <li className="font-normal text-lg">
            <a
              className="block px-4 py-2  text-[#1c3142] hover:bg-gray-100"
              onClick={() => (window.location.href = "/")}
            >
              Home
            </a>
          </li>
          <li className="font-normal text-lg">
            <a
              className="block px-4 py-2 text-[#1c3142] hover:bg-gray-100"
              onClick={() => (window.location.href = "/shop")}
            >
              Shop
            </a>
          </li>
          {isCollectionsLoading ? (
            <li></li>
          ) : (
            collections.length > 0 &&
            collections.map((collection) => (
              <li className="font-normal text-lg" key={collection._id}>
                <a
                  className="px-4 py-2 text-[#1c3142] hover:bg-gray-100 flex justify-between items-center"
                  onClick={() => (window.location.href = `/shop?collection=${collection.name}`)}
                >
                  {collection.name}
                  <ArrowSvg className="w-5 h-5" />
                </a>
              </li>
            ))
          )}
          <li className="font-normal text-lg">
            <a
              className="block px-4 py-2  text-[#1c3142] hover:bg-gray-100"
              onClick={() => router.push("/contact")}
            >
              Contact us
            </a>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default SideNavDrawer;
